<template>
  <div class="box">
    <div class="layout">
      <div class="tabs-content">
        <span v-for="item in tabs" :key="item.id" :class="[tabsActive === item.id ? 'tabs--color' : 'color444', tabWidthAuto ? 'tabs--auto' : 'tabs' ]"
         @click="clickTabs(item.id)">{{item.text}}</span>
        <div class="tabs-solid" v-if="tabSolid"></div>
      </div>
      <div style="flex: 1; overflow: auto; " class="content">
        <template v-for="tab in tabs">
          <template v-if="tab.id === tabsActive">
            <div :key="tab.id" :style="contentStyle">
              <slot :name="tab.id"></slot>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import {isMeaningful} from "../../../../utils/common";

  export default {
    name: "app-top-tabs",
    props: {
      value: {
        type: String,
        default: ''
      },
      tabs: {
        type: Array,
        default: () => ([])
      },
      contentStyle: {
        type: Object,
        default: () => {}
      },
      tabSolid: {
        type: Boolean,
        default: true
      },
      tabWidthAuto: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      type: {
        immediate: true,
        deep: true,
        handler(value) {
          if (isMeaningful(value)) {
            this.tabsActive = value;
          }
        }
      },
      value (val, oldVal) {
        if (val !== oldVal) {
          this.tabsActive = val
        }
      },
      tabsActive (val, oldVal) {
        if (val !== oldVal) {
          this.$emit('input', val)
        }
      }
    },
    data() {
      return {
        tabsActive: this.value || this.tabs[0].id,
      }
    },
    methods: {
      clickTabs(id) {
        this.tabsActive = id;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .box {
    width: 100%;
    height: 100%;
    /* padding: 10px 20px; */
    box-sizing: border-box;
  }

  .layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #ffffff;
    /* padding: 0 10px; */
    /* border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15); */
  }

  .tabs-content {
    // border-bottom: 1px solid #e8e8e8;
    width: 100%;
    position: relative;
    .tabs-solid{
      position: absolute;
      bottom: 0;
      left: 0;
      background: #e8e8e8;
      height: 1px;
      width: 100%;
      z-index: 1;
    }
  }

  .tabs {
    display: inline-block;
    width: 100px;
    text-align: center;
    margin-top: 6px;
    padding-bottom: 4px;
    cursor: pointer;
    font-size: 14px;
    z-index: 10;
    position: relative;
  }

  .tabs--auto {
    display: inline-block;
    text-align: center;
    margin-top: 6px;
    padding-bottom: 6px;
    cursor: pointer;
    font-size: 14px;
    z-index: 10;
    margin-right: 32px;
    position: relative;
  }

  .tabs--color {
    border-bottom: 2px solid #1F6EEF;
    color: #1F6EEF;
  }

  .color444 {
    color: #666;
  }

  /deep/ .table-shadow {
    box-shadow: unset;
  }

  .content /deep/ .el-table thead.is-group th {
    background: #ffffff;
  }
</style>
